import { KYMW1409Model } from '../kymw1409.model';
import { DeleteUseMarkModel } from '../../kymw1400/vo/delete-use-mark.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 使用マークを削除する。
 *
 * @export
 * @class DeleteUseMarkService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class DeleteUseMarkService extends PlessJsonResponderSub<any> {

  private model: KYMW1409Model = null;
  private vo: DeleteUseMarkModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeleteUseMarkService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.pCode.map(pCode => {
      const ogfi = (this.vo.orderGoodsFlgKoma as Array<any>).find(ogfi => ogfi.PCode == pCode);
      return {
        condition: {
          PCode: pCode,
          ReceiptSOrderCode: ogfi.ReceiptSOrderCode,
          OrderNum6Digits: ogfi.OrderNum6Digits,
          ItemCode: ogfi.itemCodeItemCode,
          OrderGoodsFlg: ogfi.OrderGoodsFlg,
        }
      };
    });

    return new PlessRequest({
      delete: {
        Mark: {
          condition: {
                OrderCode: this.vo.orderCode,
                CoopCode: this.vo.coopCode,
                MarkCode: this.vo.markCode,
                OrderGoodsFlg: this.vo.orderGoodsFlg,
          },
          combination: combinations
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1409Model} model
   * @param {DeleteUseMarkModel} vo
   * @memberof DeleteUseMarkService
   */
  execute(model: KYMW1409Model, vo: DeleteUseMarkModel) {
    this.model = model;
    this.vo = vo;
    this.send('deleteUseMark', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof DeleteUseMarkService
   */
  success(data: any) {
    // 使用マークチェックボックス設定処理
    this.model.setMark();
  }
}
